module.exports = __webpack_public_path__ + "static/img/sec2-cont-img01@m.27f4ee5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/xeogen/sec2-cont-img01@m.jpg
// module id = nKt3
// module chunks = 0